// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d30afc4a2ae40b2eeb92","655":"d0f748ce04b7cd2b8ea8"}[chunkId] + ".js";
};